export type TopBarConfig = {
    home: {
        logo: string;
        alt: string;
        showAppCode: boolean;
        logout: string;
        middleIcon?: string;
    };
    items: Array<{
        name: string;
        icon?: string;
        tooltip?: string;
        action: string;
        placeholder?: boolean;
        requireSession?: boolean;
        requiredField?: {
            field: string;
            value?: string;
        };
    }>;
    account: {
        icon: string;
        tooltip: string;
        popoverItems: Array<{
            label: string;
            icon: string;
            action: string | null;
            type?: string;
            requireSession?: boolean;
            switchProps?: {
                id: string;
                ariaLabel: string;
                defaultChecked: string;
                action: string;
            };
        }>;
    };
  };

export function setTheme() {
    framesChangeClass("dark", isDarkTheme())
}

export function framesChangeClass(className: string, add: boolean) {
    if (add) {
        document.body.classList.add(className);
        document.documentElement.setAttribute('data-bs-theme', 'dark')
    } else {
        document.body.classList.remove(className);
        document.documentElement.setAttribute('data-bs-theme', 'light')
    }
    var allFrames = document.getElementsByTagName("iframe");
    for (var i = 0; i < allFrames.length; i++) {
        if (allFrames[i].src.toLowerCase().indexOf(`${window.location.origin}/dr/`) === -1) {
            var tmp = allFrames[i].contentDocument.body;
            var frame = allFrames[i].contentDocument.documentElement;
            if (add) {
                tmp.classList.add(className);
                frame.setAttribute('data-bs-theme', 'dark');
                document.documentElement.setAttribute('data-bs-theme', 'dark');

            } else {
                tmp.classList.remove(className);
                frame.setAttribute('data-bs-theme', 'light');
                document.documentElement.setAttribute('data-bs-theme', 'light');
            }
        }
    }
}

export function isDarkTheme() {
    var val = getCookie("darkMode") === "1";
    if (val && !document.body.classList.contains('dark')) {
        document.body.classList.add("dark");
        setTheme();
    }
    return val;
}

export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}